import { ENV } from "../utils";

export class Cause {
  baseApi = ENV.BASE_API;

  async getCauses(accessToken, active = true) {
    const url = `${this.baseApi}/causes?active=${active}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createCause(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-cause`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateCause(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-cause/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteCause(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-cause/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
